export const translations = {
    EN: [
        { text: '', value: '' },
        { text: 'Apartment', value: 'APT' },
        { text: 'Suite', value: 'SUITE' },
        { text: 'Unit', value: 'UNIT' },
    ],
    FR: [ // Add translations for other languages here
        { text: '', value: '' },
        { text: 'Appartement', value: 'APT' },
        { text: 'Suite', value: 'SUITE' },
        { text: 'Unité', value: 'UNIT' },
    ],
};

export const StreetTypes = [
    { text: '', value: '' },
    { text: 'Abbey', value: 'ABBEY' },
    { text: 'Acres', value: 'ACRES' },
    { text: 'Allée', value: 'ALLéE' },
    { text: 'Alley', value: 'ALLEY' },
    { text: 'Autoroute', value: 'AUT' },
    { text: 'Avenue', value: 'AVE' },
    { text: 'Avenue', value: 'AV' },
    { text: 'Bay', value: 'BAY' },
    { text: 'Beach', value: 'BEACH' },
    { text: 'Bend', value: 'BEND' },
    { text: 'Boulevard', value: 'BLVD' },
    { text: 'Boulevard', value: 'BOUL' },
    { text: 'By-pass', value: 'BYPASS' },
    { text: 'Byway', value: 'BYWAY' },
    { text: 'Campus', value: 'CAMPUS' },
    { text: 'Cape', value: 'CAPE' },
    { text: 'Carré', value: 'CAR' },
    { text: 'Carrefour', value: 'CARREF' },
    { text: 'Centre', value: 'CTR' },
    { text: 'Centre', value: 'C' },
    { text: 'Cercle', value: 'CERCLE' },
    { text: 'Chase', value: 'CHASE' },
    { text: 'Chemin', value: 'CH' },
    { text: 'Circle', value: 'CIR' },
    { text: 'Circuit', value: 'CIRCT' },
    { text: 'Close', value: 'CLOSE' },
    { text: 'Common', value: 'COMMON' },
    { text: 'Concession', value: 'CONC' },
    { text: 'Corners', value: 'CRNRS' },
    { text: 'Côte', value: 'CÔTE' },
    { text: 'Cour', value: 'COUR' },
    { text: 'Cours', value: 'COURS' },
    { text: 'Court', value: 'CRT' },
    { text: 'Cove', value: 'COVE' },
    { text: 'Crescent', value: 'CRES' },
    { text: 'Croissant', value: 'CROIS' },
    { text: 'Crossing', value: 'CROSS' },
    { text: 'Cul-de-sac', value: 'CDS' },
    { text: 'Dale', value: 'DALE' },
    { text: 'Dell', value: 'DELL' },
    { text: 'Diversion', value: 'DIVERS' },
    { text: 'Downs', value: 'DOWNS' },
    { text: 'Drive', value: 'DR' },
    { text: 'échangeur', value: 'éCH' },
    { text: 'End', value: 'END' },
    { text: 'Esplanade', value: 'ESPL' },
    { text: 'Estates', value: 'ESTATE' },
    { text: 'Expressway', value: 'EXPY' },
    { text: 'Extension', value: 'EXTEN' },
    { text: 'Farm', value: 'FARM' },
    { text: 'Field', value: 'FIELD' },
    { text: 'Forest', value: 'FOREST' },
    { text: 'Freeway', value: 'FWY' },
    { text: 'Front', value: 'FRONT' },
    { text: 'Gardens', value: 'GDNS' },
    { text: 'Gate', value: 'GATE' },
    { text: 'Glade', value: 'GLADE' },
    { text: 'Glen', value: 'GLEN' },
    { text: 'Green', value: 'GREEN' },
    { text: 'Grounds', value: 'GRNDS' },
    { text: 'Grove', value: 'GROVE' },
    { text: 'Harbour', value: 'HARBR' },
    { text: 'Heath', value: 'HEATH' },
    { text: 'Heights', value: 'HTS' },
    { text: 'Highlands', value: 'HGHLDS' },
    { text: 'Highway', value: 'HWY' },
    { text: 'Hill', value: 'HILL' },
    { text: 'Hollow', value: 'HOLLOW' },
    { text: 'Île', value: 'ÎLE' },
    { text: 'Impasse', value: 'IMP' },
    { text: 'Inlet', value: 'INLET' },
    { text: 'Island', value: 'ISLAND' },
    { text: 'Key', value: 'KEY' },
    { text: 'Knoll', value: 'KNOLL' },
    { text: 'Landing', value: 'LANDNG' },
    { text: 'Lane', value: 'LANE' },
    { text: 'Limits', value: 'LMTS' },
    { text: 'Line', value: 'LINE' },
    { text: 'Link', value: 'LINK' },
    { text: 'Lookout', value: 'LKOUT' },
    { text: 'Loop', value: 'LOOP' },
    { text: 'Mall', value: 'MALL' },
    { text: 'Manor', value: 'MANOR' },
    { text: 'Maze', value: 'MAZE' },
    { text: 'Meadow', value: 'MEADOW' },
    { text: 'Mews', value: 'MEWS' },
    { text: 'Montée', value: 'MONTéE' },
    { text: 'Moor', value: 'MOOR' },
    { text: 'Mount', value: 'MOUNT' },
    { text: 'Mountain', value: 'MTN' },
    { text: 'Orchard', value: 'ORCH' },
    { text: 'Parade', value: 'PARADE' },
    { text: 'Parc', value: 'PARC' },
    { text: 'Park', value: 'PK' },
    { text: 'Parkway', value: 'PKY' },
    { text: 'Passage', value: 'PASS' },
    { text: 'Path', value: 'PATH' },
    { text: 'Pathway', value: 'PTWAY' },
    { text: 'Pines', value: 'PINES' },
    { text: 'Place', value: 'PL' },
    { text: 'Place', value: 'PLACE' },
    { text: 'Plateau', value: 'PLAT' },
    { text: 'Plaza', value: 'PLAZA' },
    { text: 'Point', value: 'PT' },
    { text: 'Pointe', value: 'POINTE' },
    { text: 'Port', value: 'PORT' },
    { text: 'Private', value: 'PVT' },
    { text: 'Promenade', value: 'PROM' },
    { text: 'Quai', value: 'QUAI' },
    { text: 'Quay', value: 'QUAY' },
    { text: 'Ramp', value: 'RAMP' },
    { text: 'Rang', value: 'RANG' },
    { text: 'Range', value: 'RG' },
    { text: 'Ridge', value: 'RIDGE' },
    { text: 'Rise', value: 'RISE' },
    { text: 'Road', value: 'RD' },
    { text: 'Rond-point', value: 'RDPT' },
    { text: 'Route', value: 'RTE' },
    { text: 'Row', value: 'ROW' },
    { text: 'Rue', value: 'RUE' },
    { text: 'Ruelle', value: 'RLE' },
    { text: 'Run', value: 'RUN' },
    { text: 'Sentier', value: 'SENT' },
    { text: 'Square', value: 'SQ' },
    { text: 'Street', value: 'ST' },
    { text: 'Subdivision', value: 'SUBDIV' },
    { text: 'Terrace', value: 'TERR' },
    { text: 'Terrasse', value: 'TSSE' },
    { text: 'Thicket', value: 'THICK' },
    { text: 'Towers', value: 'TOWERS' },
    { text: 'Townline', value: 'TLINE' },
    { text: 'Trail', value: 'TRAIL' },
    { text: 'Turnabout', value: 'TRNABT' },
    { text: 'Vale', value: 'VALE' },
    { text: 'Via', value: 'VIA' },
    { text: 'View', value: 'VIEW' },
    { text: 'Village', value: 'VILLGE' },
    { text: 'Villas', value: 'VILLAS' },
    { text: 'Vista', value: 'VISTA' },
    { text: 'Voie', value: 'VOIE' },
    { text: 'Walk', value: 'WALK' },
    { text: 'Way', value: 'WAY' },
    { text: 'Wharf', value: 'WHARF' },
    { text: 'Wood', value: 'WOOD' },
    { text: 'Wynd', value: 'WYND' },
];

export const StreetDirections = {
    "EN": [
        { text: '', value: '' },
        { text: 'North', value: 'N' },
        { text: 'South', value: 'S' },
        { text: 'East', value: 'E' },
        { text: 'West', value: 'W' },
        { text: 'North-east', value: 'NE' },
        { text: 'North-west', value: 'NW' },
        { text: 'South-east', value: 'SE' },
        { text: 'South-west', value: 'SW' },
    ],
    "FR": [
        { text: '', value: '' },
        { text: 'nord', value: 'N' },
        { text: 'sud', value: 'S' },
        { text: 'est', value: 'E' },
        { text: 'ouest', value: 'W' },
        { text: 'nord-est', value: 'NE' },
        { text: 'nord-ouest', value: 'NW' },
        { text: 'sud-est', value: 'SE' },
        { text: 'sud-ouest', value: 'SW' },
    ]
}

export const RouteTypes = {
    "EN": [
        { text: '', value: '' },
        { text: 'Rural route', value: 'RR' },
        { text: 'Suburban service', value: 'SS' },
        { text: 'Mobile route', value: 'MR' },
        { text: 'General delivery', value: 'GD' },
    ],
    "FR": [
        { text: '', value: '' },
        { text: 'Route Rurale', value: 'RR' },
        { text: 'Service de banlieue', value: 'SS' },
        { text: 'Itinéraire mobile', value: 'MR' },
        { text: 'Poste restante', value: 'GD' },
    ]
}

export const LotTypes = {
    "EN": [
        { text: '', value: '' },
        { text: 'LOT', value: 'L' },
        { text: 'PART LOT', value: 'P' },
        { text: 'BLOCK', value: 'B' },
        { text: 'PART BLOCK', value: 'K' },
    ],
    "FR": [
        { text: '', value: '' },
        { text: 'Parcelle', value: 'L' },
        { text: 'parc', value: 'P' },
        { text: 'Bloc', value: 'B' },
        { text: 'Bloc de pièces', value: 'K' },
    ]
};

export const PropertIdentifier = {
    "EN": [{ text: 'Concession number', value: 'CN'}, { text: 'Plan number', value: 'PN' }, { text: '', value: '' }],
    "FR": [{ text: 'Numéro de concession', value: 'CN'}, { text: 'Numéro de plan', value: 'PN' }, { text: '', value: '' }],
}

export const LotTypeMap = {
    "EN": { L: 'LOT',  P: 'PART LOT', K: 'PART BLOCK'},
    "FR": { L: 'Parcelle' , P: 'parc' ,  B: 'Bloc', K: 'Bloc de pièces' },
}

export const UnitTypeMap = {
    EN: { APT: 'Apartment', SUITE: 'Suite', UNIT: 'Unit' },
    FR: { APT: 'Appartement', SUITE: 'Suite', UNIT: 'Unité' },
};

export const PropertIdentifierMap = {
    "EN": { CN: 'Concession number',  PN: 'Plan number' },
    "FR": { CN: 'Numéro de concession',  PN: 'Numéro de plan' },
}

export const StreetNumberSuffix = [
    { text: '', value: '' },
    { text: '1/4', value: '1' },
    { text: '1/2', value: '2' },
    { text: '3/4', value: '3' },
    { text: 'A', value: 'A' },
    { text: 'B', value: 'B' },
    { text: 'C', value: 'C' },
    { text: 'D', value: 'D' },
    { text: 'E', value: 'E' },
    { text: 'G', value: 'G' },
    { text: 'H', value: 'H' },
    { text: 'I', value: 'I' },
    { text: 'J', value: 'J' },
    { text: 'K', value: 'K' },
    { text: 'L', value: 'L' },
    { text: 'M', value: 'M' },
    { text: 'N', value: 'N' },
    { text: 'O', value: 'O' },
    { text: 'P', value: 'P' },
    { text: 'Q', value: 'Q' },
    { text: 'R', value: 'R' },
    { text: 'S', value: 'S' },
    { text: 'T', value: 'T' },
    { text: 'U', value: 'U' },
    { text: 'V', value: 'V' },
    { text: 'W', value: 'W' },
    { text: 'X', value: 'X' },
    { text: 'Y', value: 'Y' },
    { text: 'Z', value: 'Z' },
];


export const Provinces = {
    "EN": [
        { text: 'Select', value: '' },
        { text: 'Alberta', value: 'AB' },
        { text: 'British Columbia', value: 'BC' },
        { text: 'Manitoba', value: 'MB' },
        { text: 'New Brunswick', value: 'NB' },
        { text: 'Newfoundland and Labrador', value: 'NL' },
        { text: 'Northwest Territories', value: 'NT' },
        { text: 'Nunavut', value: 'NU' },
        { text: 'Nova Scotia', value: 'NS' },
        { text: 'Ontario', value: 'ON' },
        { text: 'Prince Edward Island', value: 'PE' },
        { text: 'Quebec', value: 'QC' },
        { text: 'Saskatchewan', value: 'SK' },
        { text: 'Yukon', value: 'YT' },
    ],
    "FR": [
        { text: 'Select', value: '' },
        { text: "L'Alberta", value: 'AB' },
        { text: 'La Colombie-Britannique', value: 'BC' },
        { text: 'Le Manitoba', value: 'MB' },
        { text: 'Le Nouveau-Brunswick', value: 'NB' },
        { text: 'La Terre-Neuve-et-Labrador', value: 'NL' },
        { text: 'Les Territoires du Nord-Ouest', value: 'NT' },
        { text: 'Le Nunavut', value: 'NU' },
        { text: 'La Nouvelle-Écosse', value: 'NS' },
        { text: "L'Ontario", value: 'ON' },
        { text: 'Île-du-Prince-Édouard', value: 'PE' },
        { text: 'Le Québec', value: 'QC' },
        { text: 'La Saskatchewan', value: 'SK' },
        { text: 'Le Yukon (Territoire)', value: 'YT' },
    ]
}
